import { Card, message, Modal, Typography } from 'antd';
import { requestform } from 'messages';
import React, { useState } from 'react';
import { InprogressTickets } from 'types';
import { usePatchTransferToCustomerCareCenterMutation } from 'services';
import TextArea from 'antd/es/input/TextArea';

type TabKey = 'pending_reception' | 'in_progress' | 'collaboration' | 'completed' | 'obstacle';

interface ticketDetail {
  ticketId: number;
  processingContent: string;
  closeTransferCenterModal: () => void;
  cancelDetailModal: () => void;

  fetchPartialTicketCounts?: (statuses: TabKey[]) => void;
}

const ModalTransferCenter: React.FC<ticketDetail> = ({
  ticketId,
  processingContent,
  closeTransferCenterModal,
  cancelDetailModal,
  fetchPartialTicketCounts
}) => {
  const [content, setContent] = useState(processingContent || '');

  const [transferToCustomerCareCenter] = usePatchTransferToCustomerCareCenterMutation();
  const transferCustomerCareCenter = () => {
    if (!content || content.trim() === '') {
      message.error('Nhập nội dung xử lý trước khi chuyển về TTCSKH');
      return;
    }

    const data: InprogressTickets = {
      ticketId,
      processingContent: content,
      isRequestMultipleTime: false,
      isNotOnTime: false,
      isOutageEntireArea: false,
      isNotRequestToSendSms: false
    };
    Modal.confirm({
      title: 'Xác nhận chuyển TTCSKH',
      okText: 'Xác nhận',
      cancelText: 'Hủy',
      onOk() {
        if (ticketId) {
          transferToCustomerCareCenter(data)
            .unwrap()
            .then((res) => {
              closeTransferCenterModal();
              cancelDetailModal();
              message.success('Chuyển phiếu về TTCSKH thành công');
              fetchPartialTicketCounts && fetchPartialTicketCounts(['in_progress']);
            })
            .catch(() => message.error('Chuyển phiếu về TTCSKH thất bại'));
        }
      }
    });
  };

  return (
    <Card className='confirm-modal mx-auto bg-[#F5F5F7] py-4 text-center'>
      {/** --- Card Title  --- */}
      <div className='ml-6 flex justify-start'>
        <Typography.Text className='text-[26px]/[34px] font-bold text-[#141414]'>
          {requestform.confirmTransferToCustomerCenterCare}
        </Typography.Text>
      </div>

      <div className={'mx-6 my-4 mb-0 space-y-4'}>
        {/** --- Processing Content  ---*/}
        <div className='space-y-1 text-left'>
          <TextArea
            placeholder={'Nhập nội dung phản hồi'}
            value={content}
            onChange={(e) => {
              setContent(e.target.value);
            }}
            autoSize={{ minRows: 5, maxRows: 10 }}
            className='rounded-lg bg-[#F7F8F6]'
          />
        </div>

        {/** --- Confirm Button  ---*/}
        <div className={'flex justify-end'}>
          <button
            onClick={transferCustomerCareCenter}
            className='rounded-lg bg-[#28A745] px-6 py-[10px] text-[16px]/[20px] font-semibold text-[#FFFFFF]'
          >
            {requestform.confirmButton}
          </button>
        </div>
      </div>
    </Card>
  );
};

export default ModalTransferCenter;
